const formatCurrency = (currency: number): string => {
    if (isNaN(currency)) return "0"; // Return a default value if input is NaN
  
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
    });
  
    let formattedCurrency = formatter.format(currency).substring(3); // Remove "NGN"
  
    // Handle negative values
    if (formattedCurrency.startsWith("N") && !formattedCurrency.startsWith("NaN")) {
      formattedCurrency = formattedCurrency.substring(1); // Remove "N"
      formattedCurrency = "-" + formattedCurrency;
    }
  
    // Remove decimals if ".00"
    if (formattedCurrency.includes(".00")) {
      formattedCurrency = formattedCurrency.substring(0, formattedCurrency.length - 3);
    }
  
    return formattedCurrency;
  };
  

  function formatDate(dateString: string ) {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  }


  export function formatDateAndTime(createdAt: string | Date): string {
    const date = new Date(createdAt);
  
    function getOrdinalSuffix(day: number): string {
      if (day > 3 && day < 21) return `${day}th`;
      const suffixes: Record<number, string> = { 1: "st", 2: "nd", 3: "rd" };
      return `${day}${suffixes[day % 10] || "th"}`;
    }
  
    const day = getOrdinalSuffix(date.getDate());
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(date);
    const year = date.getFullYear();
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date).toLowerCase();
  
    return `${day} ${month}, ${year} ${time}`;
  }
  
  
  export { formatCurrency,formatDate };
  
